/* eslint-disable react/prop-types */
import React from 'react';
import { IconTile } from 'components/v3';
import InfoTooltip from './InfoTooltip';

// Standard card header row: orange icon tile + uppercase label + an info
// tooltip, with an optional right-aligned `actions` slot (expand button,
// range chips, etc). `icon` is a v3 Icon name, shared by the tile and tooltip.
const CardHeader = ({ icon, label, tip, forceLeft, actions }) => (
  <div className="card-title-row">
    <div className="card-title" style={{ marginBottom: 0 }}>
      <IconTile icon={icon} size={34} iconSize={18} />
      <span className="ct-label">
        {label}
        {tip ? (
          <InfoTooltip icon={icon} forceLeft={forceLeft}>
            {tip}
          </InfoTooltip>
        ) : null}
      </span>
    </div>
    {actions}
  </div>
);

export default CardHeader;
